<template>
	<v-form @submit.prevent="addRequest">
		<v-container>
			<v-row class="contentRow" align="center">
				<v-col cols="12">
					<h1 class="mb-2">Request For Onsite-Audit</h1>
					<p class="mb-10 text-center">
						This is where you can send an audit request to a supplier
					</p>
				</v-col>
				<v-col cols="12">
					<v-stepper class="elevation-0" v-model="step">
						<v-stepper-header class="elevation-0">
							<v-stepper-step
								:editable="step != '7'"
								edit-icon="fas fa-check"
								:complete="step > '1' || step == '1a' || step == '1b' || step == '1c' || step == '1d' || step == '2a' || step == '2b' || step == '2c' || step == '3a' || step == '3b'"
								step="1"
							>
								Select Auditor
							</v-stepper-step>
							<v-divider />
							<v-stepper-step
								:editable="(step > '4' ) && step != '7'"
								edit-icon="fas fa-check"
								:complete="step > '2' || step == '2a' || step == '2b' || step == '2c' || step == '3a' || step == '3b'"
								step="2"
							>
								Select Template
							</v-stepper-step>
							<v-divider />

							<v-stepper-step
								:editable="(step > '4' || step == '3a' || step == '3b') && step != '7'"
								edit-icon="fas fa-check"
								:complete="step > '3' || step == '3a' || step == '3b'"
								step="3"
							>
								Select Supplier
							</v-stepper-step>
							<v-divider />

							<v-stepper-step
								:editable="(step > '4') && step != '7'"
								edit-icon="fas fa-check"
								:complete="step > '4'"
								step="4"
							>
								Select Date
							</v-stepper-step>
							<v-divider />

							<v-stepper-step
								:editable="(step > '4') && step != '7'"
								edit-icon="fas fa-check"
								:complete="step > '4'"
								step="5"
							>
								Add Scope
							</v-stepper-step>
							<v-divider />

							<v-stepper-step
								:editable="step > '5' && step != '7'"
								:complete="step > '5'"
								edit-icon="fas fa-check"
								step="6"
							>
								Summary
							</v-stepper-step>
							<v-divider />

							<v-stepper-step step="7"> Result </v-stepper-step>
						</v-stepper-header>

						<v-stepper-content step="1">
							<v-row>
								<v-card-title>Choose Auditor Category</v-card-title>
								<v-col cols="12">
									<v-btn depressed color="secondary" @click="chooseInternalAuditor">Choose Internal Auditor</v-btn>
									<v-btn outlined color="secondary" depressed @click="chooseExternalAuditor" class="ml-3">
										Choose External Auditor </v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="1a">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Choose Internal Auditor</v-card-title>
								<v-card-subtitle>Please choose an auditor from your team or yourself</v-card-subtitle>
								<v-card-text>
									<v-select
									:items="filteredTeamMembers"
									label="Team Members"
									v-model="selectedTeamMember"
									item-text="text"
									item-value="value"
									return-object
									>
										<template v-slot:prepend-item>
											<v-list-item>
												<v-list-item-content>
													<v-text-field
													v-model="teamMemberSearch"
													placeholder="Search Team Member"
													autofocus
													append-icon="fa fa-close"
													@click:append="teamMemberSearch = ''"
													></v-text-field>
												</v-list-item-content>
											</v-list-item>
										</template>
										<template v-slot:selection="{ item }"> {{ item.value === username ? item.text + " (You)" : item.text }} </template>
										<template v-slot:item="{ item, on, attrs }">
											<v-list-item v-bind="attrs" v-on="on">
											<v-list-item-content>
												<v-list-item-title>
												{{ item.value === username ? item.text + " (You)" : item.text }}
												</v-list-item-title>
											</v-list-item-content>
											</v-list-item>
										</template>
									</v-select>
								</v-card-text>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										color="primary"
										@click="step = '2'"
										:disabled="!selectedTeamMember"
									>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="1b">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Choose External Auditor</v-card-title>
								<v-col cols="12">
									<v-btn depressed color="secondary" @click="step = '1c'">Choose Existing External Auditor</v-btn>
									<v-btn depressed outlined color="secondary"
										class="ml-3"
										@click="
											step = '1d';
											$store.dispatch(
												'connections/invitationcodes/setAuditorInvitationCodeModalOpen',
												true
											);
										"
									><v-icon left>fas fa-plus</v-icon>Invite New Auditor</v-btn>
								</v-col>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="1c">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Choose Existing External Auditor</v-card-title>
								<v-card-subtitle>Please choose an auditor from your connections</v-card-subtitle>
								<v-card-text>
									<v-select
										:items="filteredOnsiteConnectionsWithUsers"
										label="Connections"
										v-model="selectedConnection"
										item-text="text"
										item-value="value"
										>
										<template v-slot:prepend-item>
											<v-list-item>
												<v-list-item-content>
													<v-text-field
														v-model="onsiteconnectionSearch"
														placeholder="Search Connection"
														autofocus
														append-icon="fa fa-close"
														@click:append="onsiteconnectionSearch = ''"
													></v-text-field>
												</v-list-item-content>
											</v-list-item>
										</template>
										<template v-slot:item="{ item }">
											<v-list-item-content>
												<v-list-item-title>
													<template v-if="!item.isUser">
														<strong>{{ item.text }}</strong>
													</template>
													<template v-else>
														<span class="pl-6">{{ item.text }} <span class="grey--text text--darken-1">({{ item.email }})</span></span>
													</template>
												</v-list-item-title>
											</v-list-item-content>
										</template>
									</v-select>
								</v-card-text>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										color="primary"
										@click="step = '2'"
										:disabled="!selectedConnection"
									>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="1d" class="pt-0">
							<AddNewOnsiteInvitationCode
									:isAuditRequestReceiver="true"
									@updateInvitationCode="updateInvitationCode"
								/>
							<NewCodeDisplay />
							<v-card-actions>
								<v-btn color="primary" outlined @click="step = '1'">
									<v-icon left>fas fa-arrow-left</v-icon> Previous
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click="step = '2'">
									Next <v-icon right>fas fa-arrow-right</v-icon>
								</v-btn>
							</v-card-actions>
						</v-stepper-content>

						<v-stepper-content step="2">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Choose Template Category</v-card-title>
								<v-col cols="12">
									<v-btn depressed color="secondary" @click="step = '2a'">Duplicate from existing template</v-btn>
									<v-btn depressed outlined color="secondary" class="ml-3"
										:to="getNewTemplateRoute()"
									><v-icon left>fas fa-plus</v-icon>Create new template</v-btn>
								</v-col>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="2a">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Choose Template to Duplicate</v-card-title>
								<v-col cols="12">
									<v-select
										hide-details="auto"
										:items="filteredTemplates"
										label="Choose Template"
										v-model="templateID"
										item-value="value"
										class="mt-2"
										outlined
									>
										<template v-slot:prepend-item>
											<v-list-item>
												<v-list-item-content>
													<v-text-field
														v-model="templateSearch"
														placeholder="Search Template"
														autofocus
														append-icon="fa fa-close"
														@click:append="clearSearch('templateSearch')"
													></v-text-field>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-select>
								</v-col>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										color="secondary"
										:disabled="!templateID"
										@click="showPreview()"
									>
									Preview and duplicate Template <v-icon small right>fas fa-eye</v-icon></v-btn>
								</v-col>
								<!-- <v-col class="text-right">
									<v-btn
										color="primary"
										@click="step = '2b'"
									>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col> -->
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="2b">
							<v-card class="elevation-0 pb-5">
								<v-card-title>Get Approval from Auditor</v-card-title>
								<v-card-subtitle>Continue the next steps after getting the approval from Auditor</v-card-subtitle>
								<v-card-text class="text--primary">
									<p v-if="$route.query.auditor">Onsite Auditor : {{ $route.query.auditor}}</p>
									<p v-if="$route.query.invitation">Invitation code : {{ $route.query.invitation }}</p>
									<p>Template Name : {{ $route.query.templateName }}</p>
								</v-card-text>
								<v-col cols="12" class="ml-10">
									<v-btn depressed color="primary" @click="sendTemplateRequest">Submit</v-btn>
									<v-btn class="ml-10" outlined color="primary" @click="cancelTemplateRequest">Cancel and Go back</v-btn>
								</v-col>
							</v-card>
						</v-stepper-content>

						<v-stepper-content step="2c">
							<v-card class="elevation-0 pb-5">
								<div style="border: 2px solid #227e85;" align="center">
									<v-img
										alt="Success Icon"
										:src="require('../../assets/twemoji/success.svg')"
										width="75"
										class="mx-auto my-8"
									/>
									<!-- <h2>Success</h2> -->
									<p class="mb-4" style="font-size: 20px;">Successfully sent template request!</p>
								</div>
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="secondary"
											:to="{ name: 'Onsite Initiator Dashboard' }"
											align="center"
										>
										Go To Initiator View
										<v-icon right>fas fa-external-link-alt</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-card>
						</v-stepper-content>

						<v-stepper-content step="3">
							<v-row>
								<v-col cols="12">
									<v-btn depressed color="secondary" @click="step = '3a'"
										>Choose Existing Supplier</v-btn
									>
									<v-btn
										outlined
										color="secondary"
										depressed
										class="ml-3"
										@click="
											step = '3b';
											$store.dispatch(
												'connections/invitationcodes/setInvitationCodeModalOpen',
												true
											);
										"
									>
										<v-icon left>fas fa-plus</v-icon>Invite new Supplier
									</v-btn>
								</v-col>
							</v-row>
							<!-- <v-row>
								<v-col class="text-right">
									<v-btn
										color="primary"
										:disabled="true"
									>
									Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row> -->
						</v-stepper-content>

						<v-stepper-content step="3a">
							<v-card class="elevation-0">
								<v-card-title>Choose Existing Supplier</v-card-title>
								<v-card-subtitle
									>Please choose either a connection or an invitation code as a
									supplier for the onsite-audit request</v-card-subtitle
								>
								<v-card-text>
									<v-select
										:items="filteredConnectionWithUsers"
										label="Connections"
										v-model="selectedUser"
										item-text="text"
										item-value="value"
										>
										<template v-slot:prepend-item>
											<v-list-item>
												<v-list-item-content>
													<v-text-field
														v-model="connectionSearch"
														placeholder="Search Connection"
														autofocus
														append-icon="fa fa-close"
														@click:append="clearSearch('connectionSearch')"
													></v-text-field>
												</v-list-item-content>
											</v-list-item>
										</template>
										<template v-slot:item="{ item }">
											<v-list-item-content>
												<v-list-item-title>
												<template v-if="!item.isUser">
													<strong>{{ item.text }}</strong>
												</template>
												<template v-else>
													<span class="pl-6">{{ item.text }} <span class="grey--text text--darken-1">({{ item.email }})</span></span>
												</template>
												</v-list-item-title>
											</v-list-item-content>
										</template>
									</v-select>
									<b>or / and</b>
									<v-select
										:items="filteredInvitationCode"
										label="Invitation Codes"
										item-value="value"
										v-model="selectedInvitationCodes"
										:menu="isDropdownOpen"
									>
										<template v-slot:prepend-item>

											<v-list-item>
												<v-list-item-content>
													<!-- <v-btn
														color="primary"
														style="position: fixed; top: 10px; right: 10px;"
														@click="closeDropdown"
													>
														Close
													</v-btn> -->
													<v-text-field
														v-model="invitationCodeSearch"
														placeholder="Search Invitation Code"
														autofocus
														append-icon="fa fa-close"
														@click:append="clearSearch('invitationCodeSearch')"
													>
													</v-text-field>

												</v-list-item-content>
											</v-list-item>
										</template>
										<template v-slot:selection="{ item, index }">
											<v-chip v-if="index === 0">
												<span>{{ item }}</span>
											</v-chip>
											<span
												v-if="index === 1"
												class="
													grey--text
													text--darken-3
													caption
												"
											>
												(+{{ selectedInvitationCodes.length - 1 }}
												others)
											</span>
										</template>
									</v-select>
								</v-card-text>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										class="ml-4"
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										depressed
										class="mr-4"
										:disabled="
											selectedInvitationCodes.length == 0 &&
												(selectedRecipients.length == 0 || !recipientUsername)
										"
										color="secondary"
										@click="step = '4'"
										>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="3b">
							<AddNewInvitationCode
								:isAuditRequestReceiver="true"
								@updateInvitationCode="updateInvitationCode"
							/>
							<NewCodeDisplay />
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										color="primary"
										@click="step = '4'"
										:disabled="selectedInvitationCodes.length == 0"
									>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="4">
							<v-card class="elevation-0">
								<v-card-title>Schedule Your Date</v-card-title>
								<v-card-subtitle
									>Please choose a particular date or a date range about your visiting date</v-card-subtitle
								>
								<v-row>
									<v-col cols="12" sm="6">
										<v-text-field type="date" outlined label="From Date" v-model="dateRange.from"
										:min="new Date().toISOString().split('T')[0]"/>
									</v-col>
									<v-col cols="12" sm="6">
										<v-text-field type="date" outlined label="To Date" v-model="dateRange.to"
										:min="dateRange.from ? dateRange.from : new Date().toISOString().split('T')[0]"
										/>
									</v-col>
								</v-row>
								<div v-if="dateRange.from && dateRange.to" class="d-flex justify-center mt-n3 mb-n3">
									<v-text-field type="number" outlined label="Number of visit days" style="max-width: 200px;" :min="1" v-model="visitDays"/>
								</div>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										class="ml-4"
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										depressed
										class="mr-4"
										:disabled="!dateRange.from && !dateRange.to"
										color="secondary"
										@click="step = '5'"
										>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="5">
							<v-card class="elevation-0" style="border: 2px solid #227e85;" align="center">
								<v-card-title style="font-weight: bold; color: #227e85; margin-left: 38%;">Add Objective and Scope</v-card-title>
								<v-card-subtitle>Specify Standards or Key Inspection Points for Onsite Audit</v-card-subtitle>
								<v-row justify="center">
									<v-col cols="8">
										<v-textarea
											v-model="hint"
											align="center"
											placeholder="Enter your objectives and scope:"
											outlined
											auto-grow
											class="my-3"
										></v-textarea>
										<!-- <v-text-field
										v-model="hint"
										align="center"
										placeholder="Enter your objectives and scope:"
										outlined
										class="my-3"
										></v-text-field> -->
									</v-col>
								</v-row>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										class="ml-4"
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										depressed
										class="mr-4"
										:disabled="!dateRange.from && !dateRange.to"
										color="secondary"
										@click="step = '6'"
										>
										Next<v-icon right>fas fa-arrow-right</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="6">
							<v-card class="elevation-0" style="border: 2px solid #227e85;" align="center">
								<v-card-title style="font-weight: bold; color: #227e85; margin-left: 44%;">Summary</v-card-title>
								<v-card-subtitle>
									Review the details of the request below.
								</v-card-subtitle>
								<v-card-text class="text--primary">
									<p style="font-size: 0.95rem">
										Template:
										<b
											>'{{
												templateID
													? templates.filter(t => {
															return t.value == templateID
													})[0].text
													: ""
											}}'</b
										>
										<!-- (ID: {{ templateID }}) -->
									</p>
									<p style="font-size: 0.95rem" v-if="onsiteAuditor" >
										Will be sent to Auditor : '<b>{{ onsiteAuditor }}</b>'
									</p>
									<p style="font-size: 0.95rem" v-if="selectedUser">
										Will be sent to supplier: '<b>{{
											(filteredConnectionWithUsers.find(item => item.value === selectedUser && item.isUser) || {}).text ||
											(connections.find(c => c.value === selectedRecipients[0]) || {}).text || 'Unknown'
										}}</b>'
									</p>
									<p style="font-size: 0.95rem" v-if="selectedInvitationCodes.length > 0">
										Will be sent to invitation code: '<b>{{ selectedInvitationCodes[0] }}</b>'
									</p>
									<p style="font-size: 0.95rem" v-if="dateRange.from && dateRange.to">
										The onsite audit will be conducted on one day between : '<b>from {{ dateRange.from }} to {{ dateRange.to }}</b>'
									</p>
									<p style="font-size: 0.95rem" v-else>
										The onsite audit will be conducted on : '<b>{{ dateRange.from || dateRange.to }}</b>'
									</p>
								</v-card-text>
							</v-card>
							<v-row>
								<v-col class="text-left">
									<v-btn
										color="primary"
										outlined
										:disabled="step == '1' || step == '7'"
										@click="previousStep"
									>
										<v-icon left>fas fa-arrow-left</v-icon> Previous Step
									</v-btn>
								</v-col>
								<v-col class="text-right">
									<v-btn
										color="primary"
										type="submit"
										@click="step = '7'"
										align="center"
									>
										Send Request{{
											selectedRecipients.length +
												selectedInvitationCodes.length >
											1
												? "s"
												: ""
										}}
										<v-icon right>fas fa-paper-plane</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>

						<v-stepper-content step="7">
							<div v-if="!error">
								<!-- <v-icon color="success" class="mx-auto" x-large
								>fas fa-check-circle</v-icon
								> -->
								<div style="border: 2px solid #227e85;" align="center">
									<v-img
										alt="Success Icon"
										:src="require('../../assets/twemoji/success.svg')"
										width="75"
										class="mx-auto my-8"
									/>
									<!-- <h2>Success</h2> -->
									<p class="mb-4" style="font-size: 20px;">Successfully sent audit request!</p>
								</div>
								<v-row>
									<v-col class="text-left">
										<v-btn
											color="secondary"
											:to="{ name: 'Onsite Initiator Dashboard' }"
											align="center"
										>
										Go To Initiator View
										<v-icon right>fas fa-external-link-alt</v-icon>
										</v-btn>
									</v-col>
									<v-col class="text-right">
										<v-btn color="primary" @click="resetForm" align="center">
										Send Another Request
											<v-icon right>fas fa-plus</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</div>
							<div v-else>
								<div style="border: 2px solid red;" align="center">
									<v-icon color="error" class="mx-auto" x-large
										>fas fa-times-circle</v-icon
									>
									<h2>Error</h2>
									<p>Could not complete audit request!</p>
									<p>{{ error }}</p>
								</div>
								<v-btn color="error" @click="resetForm" align="center">
									Send New Request
									<v-icon right>fas fa-undo-alt</v-icon>
								</v-btn>
							</div>
						</v-stepper-content>
					</v-stepper>
				</v-col>
			</v-row>
			<!-- <v-dialog v-model="dialog" max-width="500px">
				<v-card>
					<v-card-title>Choose Recipient</v-card-title>
					<v-card-subtitle
						>Please choose either a connection or an invitation code as a
						recipient for the audit request</v-card-subtitle
					>
					<v-card-text>
						<v-select
							:items="connections"
							label="Connections"
							v-model="selectedRecipients"
							multiple
						>
							<template v-slot:selection="{ item, index }">
								<v-chip v-if="index === 0">
									<span>{{ item }}</span>
								</v-chip>
								<span v-if="index === 1" class="grey--text caption">
									(+{{ selectedRecipients.length - 1 }}
									others)
								</span>
							</template>
						</v-select>
						<v-autocomplete
							:items="invitationCodes"
							label="Invitation Codes"
							item-value="value"
							v-model="invitationCode"
						></v-autocomplete>
					</v-card-text>
					<v-card-actions>
						<v-btn color="primary" text v-on:click="dialog = false" outlined
							>Select</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog> -->
			<v-dialog
				v-model="dialogPreview"
				max-width="1200px"
				height="auto"
				scrollable
				align = "center">
				<v-card>
					<v-card-actions class="pt-7 pr-8" style="justify-content: flex-end">
						<v-btn
							class="primary"
							color="white"
							text
							:to="getDuplicateTemplateRoute()"
							outlined
						>Duplicate template
						</v-btn>
						<v-btn
							class="success"
							color="white"
							text
							@click="dialogPreview = false; preview = false"
							outlined
						>Close</v-btn>
					</v-card-actions>
					<v-card-text class="background-color: white">
						<template-preview v-if="preview"
							:previewID="templateID"
							:preview="true"
						/>
					</v-card-text>

				</v-card>
			</v-dialog>
		</v-container>
	</v-form>
</template>

<script>
import LoadingState from "../../consts/LoadingState"
import ConnectionAPI from "../../api/connections/connection"
import TemplateAPI from "../../api/audit/template"
import RequestAPI from "../../api/audit/request"
import AddNewInvitationCode from "../../components/InvitationCodes/AddNew"
import NewCodeDisplay from "../../components/InvitationCodes/NewCodeDisplay"
import InvitationCodesAPI from "../../api/connections/invitationcodes"
import TemplatePreview from "./OnsiteTemplatePreview.vue"
import UsersAPI from "../../api/connections/users"
import OnsiteConnectionAPI from "../../api/connections/connection"
import AddNewOnsiteInvitationCode from "../../components/InvitationCodes/AddNewOnsite"
import { mapGetters } from "vuex"
export default {
	name: "RequestAudit",
	components: {
		AddNewOnsiteInvitationCode,
		AddNewInvitationCode,
		NewCodeDisplay,
		"template-preview" : TemplatePreview,
	},
	data() {
		return {
			step: this.$route.query.step || "1",
			dialog: false,
			dialogPreview: false,
			//Placeholder Data
			templates: [
				{
					text: "Loading templates...",
					value: "test" /*disabled: true*/
				}
			],
			connections: [
				{
					text: "Loading connections...",
					value: "test" /*disabled: true*/
				}
			],
			invitationCodes: [],
			recipient: null,
			templateID: null,
			invitationCode: null,
			selectedRecipients: [],
			onsiteAuditor: null,
			selectedInvitationCodes: [],
			inviteCodeDialog: false,
			expirydate: 0,
			error: null,
			preview: false,
			templateSearch: "",
			connectionSearch: "",
			memberSearch: "",
			invitationCodeSearch: "",
			isDropdownOpen: true,
			oldStep: null,
			dateRange: {
				from: null,
				to: null
			},
			hint: null,
			selectedTeamMember: null,
			selectedConnection: null,
			teamMemberSearch: "",
			onsiteconnectionSearch: "",
			selectedAuditor: null,
			teamMembers: [],
			onsiteconnections: [],
			auditorUserName: null,
			auditorType: null,
			visitDays: null,
			companyMembers: {},
			selectedUser: null,
			recipientUsername: null,
			onsiteAuditorMembers: {},
		}
	},
	watch: {
		step(newValue, oldValue) {
			this.oldStep = oldValue
		},
		selectedUser(newVal) {
			if (newVal) {
				if (newVal.includes(":")) {
					const [clientID, username] = newVal.split(":")
					this.selectedRecipients = [clientID]
					this.recipientUsername = username
				}
				this.selectedInvitationCodes = []
			} else {
				this.selectedRecipients = []
				this.recipientUsername = null
			}
		},
		selectedConnection(newVal) {
			if (newVal) {
				if (typeof newVal === "string" && newVal.includes(":")) {
					const [clientID, username] = newVal.split(":")
					this.selectedAuditor = clientID
					this.auditorUserName = username
				} else {
					this.selectedAuditor = newVal
					this.auditorUserName = null
				}
			} else {
				this.selectedAuditor = null
				this.auditorUserName = null
			}
		},
	},
	mounted() {
		this.loadConnections()
		this.loadTemplates()
		this.loadInvitations()
		this.loadTeamMembers()
		this.loadOnsiteConnections()

		if (this.$route.query.step) {
			this.step = this.$route.query.step
		}
		if (this.$route.query.templateID) {
			this.templateID = this.$route.query.templateID
		}
		if (this.$route.query.auditor) {
			this.selectedAuditor = this.$route.query.auditor
		}
		if (this.$route.query.userName) {
			this.auditorUserName = this.$route.query.userName
		}
		if (this.$route.query.auditorType) {
			this.auditorType = parseInt(this.$route.query.auditorType)
		}
		if (this.$route.query.invitation) {
			this.selectedInvitationCodes = [this.$route.query.invitation]
		}
		if (this.$route.query.auditorName) {
			this.onsiteAuditor = this.$route.query.auditorName
		}
		
	},
	computed: {
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		username() {
			return this.getUser.username
		},
		filteredTemplates() {
			if (!this.templateSearch) {
				return this.templates
			}

			return this.templates.filter((template) => {
				return template.text.toLowerCase().indexOf(this.templateSearch.toLowerCase()) > -1
			})
		},
		selectedAuditorName() {
			if (this.selectedTeamMember && this.selectedTeamMember.text) {
				return this.selectedTeamMember.text
			}
			if (this.selectedConnection && this.selectedConnection.text) {
				return this.selectedConnection.text
			}
			return "No auditor selected"
		},
		selectedAuditorID() {
			if (this.selectedTeamMember && this.selectedTeamMember.value) {
				return this.selectedTeamMember.value
			}
			if (this.selectedConnection && this.selectedConnection.value) {
				return this.selectedConnection.value
			}
			return "No auditor selected"
		},
		filteredTeamMembers() {
			if (!this.teamMemberSearch) {
				return this.teamMembers
			}

			return this.teamMembers.filter((member) => {
				return member.text.toLowerCase().indexOf(this.teamMemberSearch.toLowerCase()) > -1
			})
		},
		filteredOnsiteConnections() {
			if (!this.onsiteconnectionSearch) {
				return this.onsiteconnections
			}
			return this.onsiteconnections.filter((connection) => {
				return connection.text.toLowerCase().indexOf(this.onsiteconnectionSearch.toLowerCase()) > -1
			})
		},
		/* filteredConnection() {
			if (!this.connectionSearch) {
				return this.connections
			}

			return this.connections.filter((connection) => {
				return connection.text.toLowerCase().indexOf(this.connectionSearch.toLowerCase()) > -1
			})
		}, */
		filteredInvitationCode() {
			if (!this.invitationCodeSearch) {
				return this.invitationCodes
			}

			return this.invitationCodes.filter((invitationCode) => {
				return invitationCode.text.toLowerCase().indexOf(this.invitationCodeSearch.toLowerCase()) > -1
			})
		},
		filteredConnectionWithUsers() {
			const search = (this.connectionSearch || "").toLowerCase()
			const results = []

			this.connections.forEach((conn) => {
				if (!conn || !conn.text) return 
				const connText = conn.text.toLowerCase()

				const members = this.companyMembers?.[conn.value] || []

				const filteredUsers = members.filter((user) => {
					const name = user?.fullname?.toLowerCase?.() || ""
					return name.includes(search)
				})

				const connectionMatch = connText.includes(search)

				if (connectionMatch || filteredUsers.length > 0) {
					results.push({
						text: conn.text,
						value: conn.value,
						isUser: false,
						disabled: true
					})
					filteredUsers.forEach((user) =>
						results.push({
							text: user.fullname || "Unnamed User",
							email: user.email || "No Email",
							value: `${conn.value}:${user.username || "unknown"}`,
							isUser: true
						})
					)
				}
			})

			return results.length
				? results
				: [{ text: "No matches found", value: null, disabled: true }]
		},
		filteredOnsiteConnectionsWithUsers() {
			const search = (this.onsiteconnectionSearch || "").toLowerCase()
			const results = []

			// Use the onsiteconnections array which has the company names
			this.onsiteconnections.forEach((company) => {
				const companyName = company.text.toLowerCase()
				const clientID = company.value
				
				const users = this.onsiteAuditorMembers[clientID] || []
				
				const filteredUsers = users.filter((user) => {
					const name = user?.fullName?.toLowerCase?.() || ""
					const email = user?.email?.toLowerCase?.() || ""
					return name.includes(search) || email.includes(search)
				})

				const companyMatch = companyName.includes(search)

				if (companyMatch || filteredUsers.length > 0) {
					// Add company header with the actual company name
					results.push({
						text: company.text, // This will show "Axcil PVT Ltd" instead of "Company 8"
						value: clientID,
						isUser: false,
						disabled: true
					})
					
					// Add users under the company
					filteredUsers.forEach((user) =>
						results.push({
							text: user.fullName || "Unnamed User",
							email: user.email || "No Email",
							value: `${clientID}:${user.username || "unknown"}`,
							isUser: true
						})
					)
				}
			})

			return results.length
				? results
				: [{ text: "No matches found", value: null, disabled: true }]
		}

	},
	methods: {
		clearSearch(searchField) {
			this[searchField] = ""
		},
		updateInvitationCode(updatedInvitationCode) {
			this.selectedInvitationCodes.push(updatedInvitationCode)
			if (updatedInvitationCode) {
				this.selectedRecipients = []
			}
		},
		cancelTemplateRequest(){
			this.$router.push("/auditonsite/onsitesender/newonsite")
			location.reload()
		},
		loadTeamMembers() {
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, { root: true })
			UsersAPI.getOnsiteUsers()
				.then(rawdata => {
					this.teamMembers = []
					for (let entry of rawdata) {
						this.teamMembers.push({
							text: entry.fullname ? `${entry.fullname}` : entry.username,
							value: entry.username
						})
					}
					this.$store.dispatch("loading/" + LoadingState.ACTION_END_LOADING, null, { root: true })
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadOnsiteConnections() {
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null, { root: true })

			OnsiteConnectionAPI.getOnsiteConnections()
				.then(data => {
					this.onsiteconnections = []
					this.onsiteAuditorMembers = {} // Store users by company
					
					// Group users by clientID
					const groupedData = {}
					for (let entry of data) {
						if (!groupedData[entry.clientID]) {
							groupedData[entry.clientID] = {
								clientID: entry.clientID,
								name: entry.name, // Store the company name here
								users: []
							}
						}
						groupedData[entry.clientID].users.push({
							username: entry.username,
							fullName: entry.fullName,
							email: entry.email
						})
					}
					
					// Store both the users AND the company names
					for (let clientID in groupedData) {
						this.onsiteAuditorMembers[clientID] = groupedData[clientID].users
						// Also store company names separately for easy access
						this.onsiteconnections.push({
							value: clientID,
							text: groupedData[clientID].name,
							remove: null
						})
					}
					
					this.$store.dispatch("loading/" + LoadingState.ACTION_STOP_LOADING, null, { root: true })
				})
				.catch(error => {
					this.$store.dispatch("loading/" + LoadingState.ACTION_SET_ERROR, error, { root: true })
				})
		},
		chooseInternalAuditor() {
			this.auditorType = 1
			this.step = "1a"
		},
		chooseExternalAuditor() {
			this.auditorType = 2
			this.step = "1b"
		},
		getNewTemplateRoute() {
			const baseQuery = {
				templateID: this.templateID,
				allowOnsite: 1,
				auditorType: this.auditorType
			}

			if (this.selectedInvitationCodes.length > 0) {
				return {
					path: "/auditonsite/onsitetemplates/newOnsite",
					query: {
						...baseQuery,
						invitation: this.selectedInvitationCodes[0]
					}
				}
			}

			if (this.selectedConnection && typeof this.selectedConnection === "string" && this.selectedConnection.includes(":")) {
				const [clientID, username] = this.selectedConnection.split(":")
				const users = this.onsiteAuditorMembers[clientID] || []
				const user = users.find(u => u.username === username)
				
				return {
					path: "/auditonsite/onsitetemplates/newOnsite",
					query: {
						...baseQuery,
						auditor: user ? user.fullName : username,
						userName: username
					}
				}
			}
			
			return {
				path: "/auditonsite/onsitetemplates/newOnsite",
				query: {
					...baseQuery,
					auditor: this.selectedAuditorName,
					userName: this.selectedAuditorID
				}
			}
		},
		getDuplicateTemplateRoute() {
			const baseQuery = {
				templateID: this.templateID,
				auditorType: this.auditorType,
			}

			if (this.selectedInvitationCodes.length > 0) {
				return {
					path: "/auditonsite/onsitetemplates/duplicate",
					query: {
						...baseQuery,
						invitation: this.selectedInvitationCodes[0]
					}
				}
			}

			if (this.selectedConnection && typeof this.selectedConnection === "string" && this.selectedConnection.includes(":")) {
				const [clientID, username] = this.selectedConnection.split(":")
				const users = this.onsiteAuditorMembers[clientID] || []
				const user = users.find(u => u.username === username)
				
				return {
					path: "/auditonsite/onsitetemplates/duplicate",
					query: {
						...baseQuery,
						auditor: user ? user.fullName : username,
						userName: username
					}
				}
			}

			return {
				path: "/auditonsite/onsitetemplates/duplicate",
				query: {
					...baseQuery,
					auditor: this.selectedAuditorName,
					userName: this.selectedAuditorID
				}
			}
		},
		sendTemplateRequest(){
			const templateApproval = 0
			let invitationCode = this.selectedInvitationCodes[0]

			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null,{ root: true })

			if (this.selectedInvitationCodes.length > 0) {
				this.auditorUserName = null
				this.selectedAuditor = null
			}
			if (!this.selectedInvitationCodes.length > 0) {
				invitationCode = null
			}
	
			TemplateAPI.addTemplateRequest(this.templateID, templateApproval, this.auditorUserName, this.selectedAuditor, this.auditorType, invitationCode)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an onsite-audit template request`,
						{ root: true }
					)
					this.$router.replace({
						query: {
							...this.$route.query,
							step: "2c"
						}
					})
					location.reload()
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadConnections() {
			ConnectionAPI.getConnections()
				.then(data => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							value: entry.clientID,
							text: entry.name,
							remove: null
						})
						this.loadCompanyMembers(entry.clientID)
					}
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadCompanyMembers(clientID) {
			UsersAPI.getCompanyMembers(clientID)
				.then(data => {
					this.$set(this.companyMembers, clientID, data)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadInvitations() {
			InvitationCodesAPI.list({ hasBeenRedeemed: false })
				.then(data => {
					this.invitationCodes = []
					for (let entry of data.items) {
						this.invitationCodes.push({
							text: `${entry.name} (${entry.invitationCode})`,
							value: entry.invitationCode
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		loadTemplates() {
			TemplateAPI.getActiveTemplates(0,1)
				.then(data => {
					this.templates = []
					for (let entry of data.data) {
						this.templates.push({
							value: entry.ID,
							text: `${entry.Name}`,
							remove: null
						})
					}
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		addRequest() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			RequestAPI.addRequest(
				this.templateID,
				this.selectedRecipients,
				this.selectedInvitationCodes,
				this.expirydate,
				0,
				this.onsiteAuditor,
				this.dateRange.from,
				this.dateRange.to,
				this.hint,
				this.visitDays,
				this.recipientUsername
			)
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully sent an audit request with ID '${data}' to recipients`,
						{ root: true }
					)
					this.templateID = null
					this.recipient = null
					this.error = null
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		resetForm() {
			this.recipient = null
			this.invitationCode = null
			this.templateID = null
			this.step = "1"
			this.error = null
		},
		previousStep() {
			if (this.step == "1" || this.step > "6") {
				return
			}else if (this.step == "1a" || this.step == "1b") {
				this.step = "1"
			} else if (this.step == "1c" || this.step == "1d") {
				this.step = "1b"
			} else if (this.step == "2a" || this.step == "2b" || this.step == "2c") {
				this.step = "2"
			}  else if (this.step == "2") {
				this.step = "1"
			} else if (this.step == "3") {
				this.step = "2"
			} else if (this.step == "3a" || this.step == "3b") {
				this.step = "3"
			} else if (this.step == "4") {
				this.step = "3"
			} else if (this.step == "5") {
				this.step = 4
			} else if (this.step == "6") {
				this.step = "5"
			}
		},
		showPreview() {
			this.preview = true
			this.dialogPreview = true
		},
	}
}
</script>
